import React, { useEffect, useRef, useState, useId } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@mui/material'
import styles from './Action.module.sass'
import FormattedInput from './debouncedInput'

const MaxField = ({ label, value, setValue, valuePrecision, valueSymbol, onMaxClick }) => {
  const { t } = useTranslation()
  const [isFocused, setIsFocused] = useState(false)
  const blurTimeoutRef = useRef(null)
  const inputId = useId()

  useEffect(() => { 
    return () => {
      if (blurTimeoutRef.current) {
        clearTimeout(blurTimeoutRef.current)
      }
    }
  }, [])

  const handleFocus = () => {
    if (blurTimeoutRef.current) {
      clearTimeout(blurTimeoutRef.current)
    }
    setIsFocused(true)
  }

  const handleBlur = () => {
    if (blurTimeoutRef.current) {
      clearTimeout(blurTimeoutRef.current)
    }
    blurTimeoutRef.current = setTimeout(() => {
      setIsFocused(false)
    }, 150)
  }

  return (
    <label className={styles.field} htmlFor={inputId}>
      <div className={styles.label}>{t(label)}</div>
      <FormattedInput
        className={styles.input}
        type="text"
        name={label}
        id={inputId}
        value={value}
        onValueChange={setValue}
        precision={valuePrecision}
        onFocus={handleFocus}
        onBlur={handleBlur}
      />
      <div className={`${styles.currency}`}>
        {isFocused ? (
          <Button 
            onMouseDown={(e) => { e.preventDefault(); e.stopPropagation(); }}
            onClick={onMaxClick}
          >
            Max
          </Button>
        ) : (
         valueSymbol
        )}
      </div>
    </label>
  )
}

export default MaxField